<ion-row *ngIf="loading">
    <ion-col size="12" class="ion-text-center">
        <ion-spinner color="primary"></ion-spinner>
    </ion-col>
</ion-row>
<!-- Enrollment flow: auto-selected Saturday 9am Pacific -->
<ion-row *ngIf="!browsecommunities && selectedworkshop && customertzdisplay">
    <ion-col size="12" class="ion-text-center">
        <ion-row>
            <ion-col size="8" class="ion-text-left ion-align-self-center">
                <p class="workshop-title">Your workshop is on <span class="{{selectedworkshop.timeslot.days}}-color">{{selectedworkshop.timeslot.days}}</span> {{selectedworkshop.timeslot.timeslot | lowercase}}s</p>
                <p class="workshop-time">from <b>{{selectedworkshop.timeslot.starttime}}</b> to <b>{{selectedworkshop.timeslot.endtime}}</b> your time ({{this.customertzdisplay}})</p>
            </ion-col>
            <ion-col size="4" class="ion-text-center ion-align-self-center ion-padding-horizontal">
                <img src="/assets/imgs/business/illustration-online-workshop-screen-only.svg" alt="Saturday Workshops">
            </ion-col>
        </ion-row>
    </ion-col>
</ion-row>
<!-- Browse communities flow: show timezone selection grid -->
<ion-row *ngIf="browsecommunities && customertzdisplay">
    <ion-col size-lg="6" size="12" *ngFor="let day of onlineworkshops" style="padding: 0 4px">
        <ion-row>
            <ion-col size="12" class="workshopday-font ion-padding-bottom ion-text-center">
                <p><span class="{{day.workshopday}}-color">{{day.workshopday}}</span> Workshops</p>
            </ion-col>
        </ion-row>
        <ion-row *ngFor="let workshop of day.timeslots">
            <ion-col size="12" class="ion-text-center hover ion-padding-bottom" (click)="selectWorkshopTimeZone(day.workshopday, workshop)">
                <ion-row class="workshop-option">
                    <ion-col size="2" class="ion-text-center ion-align-self-center workshop-option-text-icon">
                        <div class="step-number">{{workshop.index}}</div>
                    </ion-col>
                    <ion-col size="10" class="ion-text-left ion-align-self-center workshop-option-text-text">From <b>{{workshop.timeslot.starttime}}</b> to <b>{{workshop.timeslot.endtime}}</b> your time<br><span style="font-size: smaller;">({{this.customertzdisplay}})</span></ion-col>
                </ion-row>
            </ion-col>
        </ion-row>
    </ion-col>
</ion-row>